// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"601":"b744de9a","924":"91778d00"}[chunkId] + ".js";
};